<!-- ════════════ NAVBAR ════════════ -->
<nav class="unav">
  <div class="container-fluid">
    <a class="unav-brand" routerLink="/">
      <img src="assetses/img/logo.png" alt="UMYOBizDFW">
      <span>UMYO<em>BizDFW</em></span>
    </a>
    <button class="unav-tog" id="navTog" (click)="toggleNav()"><span></span><span></span><span></span></button>
    <ul class="unav-links" id="navLinks" [class.nav-open]="isNavOpen">
      <li><a href="/">Home</a></li>
      <li><a href="/about">About Us</a></li>
      <li><a routerLink="/networks" class="active">Network</a></li>
      <li><a routerLink="/hub">Hub</a></li>
      <li><a routerLink="/anti-bullying">Anti-Bullying</a></li>
      <li><a routerLink="/community-impact">Community Fund</a></li>
      <li><a routerLink="/empower-youth">Empower Youth</a></li>
      <li><a routerLink="/services">Type of Servcies</a></li>
      <li><a routerLink="/cf">Card Features</a></li>
    </ul>
    <!-- <a href="/#registration-form" class="unav-cta" >Join $2.54/mo</a> -->
  </div>
</nav>

<!-- ════════════ HERO ════════════ -->
<section class="uhero ns">
  <div class="cg"></div>
  <div class="orb orb1"></div>
  <div class="orb orb2"></div>
  <div class="container" style="padding-top:20px;position:relative;z-index:1;">
    <div class="row align-items-center gy-5">
      <div class="col-lg-7">
        <p class="hero-ey">Dallas–Fort Worth's Community Platform</p>
        <h1 class="hero-t">
          Claim Your Name.<br><span class="ac">Own Your Game.</span>
        </h1>
        <p class="hero-sub">Built for the Community. Powered by Purpose.</p>
        <div class="hero-badges">
          <span class="hbg">🔒 Privacy-Gated</span>
          <span class="hbg">🏙️ DFW Exclusive</span>
          <span class="hbg">🥊 Anti-Bullying Backed</span>
          <span class="hbg">💸 Local Reinvestment</span>
        </div>
        <div class="hero-btns">
          <a href="/#registration-form" class="btn-c" >🌐 Join for Just $2.54/month</a>
        </div>
      </div>
      <div class="col-lg-5 d-none d-lg-flex justify-content-center">
        <div class="hv">
          <div class="ro">
            <div class="rn">🏙️</div>
            <div class="rn">🥊</div>
            <div class="rn">💼</div>
            <div class="ri"><img src="assetses/img/logo.png" alt="Logo"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="scr">
    <div class="scl"></div>
    <span>Scroll</span>
  </div>
</section>

<!-- ════════════ STATS BAR ════════════ -->
<div class="usb ns">
  <div class="container">
    <div class="ust"><span class="usn">$2.54</span><span class="usl">Monthly Membership</span></div>
    <div class="usd"></div>
    <div class="ust"><span class="usn">20%</span><span class="usl">Anti-Bullying Funding</span></div>
    <div class="usd"></div>
    <div class="ust"><span class="usn">DFW</span><span class="usl">Exclusive Region</span></div>
    <div class="usd"></div>
    <div class="ust"><span class="usn">UFC</span><span class="usl">Fighter Backed</span></div>
    <div class="usd"></div>
    <div class="ust"><span class="usn">100K+</span><span class="usl">Audience Reach</span></div>
  </div>
</div>


<!---- CARDS SECTION--->
<section>
  <div class="packages ">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-9">
          <p class=" mt-5 text-center text" data-aos="fade-up">
          UMYO DFW Hub is more than a network — it’s a movement rooted in Dallas–Fort Worth, designed to uplift, invest, and empower individuals, entrepreneurs, and change-makers across the Metroplex. Whether you're a student, small business owner, tradesperson, or community builder, UMYO is your platform to rise — personally, professionally, and financially.
        </p>
        </div>
      </div>
      <div class="row ">
        <div class="col-lg-6 col-md-9 mb-3 mb-lg-0 px-4">
          <div class="membership-cards h-100" data-aos="fade-right">
            <div class="card networkcard border-white gift h-100">
              <svg xmlns="http://www.w3.org/2000/svg" fill="#0d6efd" viewBox="0 0 24 24" stroke="#00D4FF" width="100" height="100">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M12 14l9-5-9-5-9 5 9 5zm0 0v6m0-6l-9-5m18 0l-9 5"/>
              </svg>
              <h3 class="text-center">Weekly Scholarships for DFW Residents</h3>
              <b class="text-center">Your effort matters — and we’re here to support your journey.</b>
              <p class="text-center"> Every week, UMYO DFW Hub awards scholarships to local residents pursuing:</p>
            <ul class="ps-3">
              <li >Community Colleges</li>
              <li>Trade & Technical Schools</li>
              <li>Business Certifications</li>
              <li>GED & Adult Education Programs</li>
            </ul>
              <p class="mt-3 text-center">We believe in funding futures and breaking barriers — one goal at a time.</p>           
          </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-9 mb-3 mb-lg-0 px-4">
          <div class="membership-cards h-100 " data-aos="fade-left">
            <div class="card networkcard border-white gift h-100" >
              <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 24 24" stroke="#00D4FF" fill="#ff6f61" stroke-width="1">
                <path d="M12 2a7 7 0 0 0-4 12v2h8v-2a7 7 0 0 0-4-12z"/>
                <path d="M9 18h6m-6 2h6"/>
              </svg>
            <h3 class="text-center">Community Contests & Recognition</h3>
            <b class="text-center">Your impact deserves to be seen.</b>
            <p class="text-center"> From local service and leadership to creative solutions and small business excellence — we host weekly contests celebrating community excellence. Winners receive:</p>
            <ul class="ps-3">
              <li >Recognition across the UMYO DFW Network</li>
              <li>Valuable prizes and sponsorship offers</li>
              <li>Resources to scale their vision</li>
            </ul> 
          </div>
          </div>
        </div>
      </div>

        <div class="row mt-5">
          <div class="col-lg-6 col-md-9 mb-3 mb-lg-0 px-4">
          <div class="membership-cards h-100 mb-3" data-aos="fade-right">
            <div class="card networkcard border-white gift  h-100" >
              <svg xmlns="http://www.w3.org/2000/svg" fill="#198754" width="80" height="80" viewBox="0 0 24 24" stroke="#00D4FF">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M20 12v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7m16 0H4m16 0l-2.5-4.5M4 12l2.5-4.5M12 12V4m0 0c-1 1.5-2 2.5-4 2.5S5 5.5 5 4s1.5-2.5 3-2.5 3 1 4 2.5zm0 0c1 1.5 2 2.5 4 2.5s3-1 3-2.5S17.5 1.5 16 1.5 13 2.5 12 4z"/>
              </svg>
            <h3 class="text-center">Weekly Gift Cards & Business Vouchers</h3>
            <b class="text-center">Support the DFW economy. Fuel our communities.</b>
            <p class="text-center">We’re reinvesting in the region by offering:</p>
            <ul class="ps-3">
              <li >$250 and $500 gift cards</li>
              <li>Redeemable at verified Black-owned and local DFW businesses</li>
            </ul>
            <p class="mt-3 text-center">Spend Local. Grow Local. Win Together.</p>  
          </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-9 mb-3 mb-lg-0 px-4">
          <div class="membership-cards h-100 mb-3" data-aos="fade-left">
            <div class="card networkcard border-white gift h-100" >
              <svg xmlns="http://www.w3.org/2000/svg" fill="#6f42c1" width="80" height="80" viewBox="0 0 24 24" stroke="#00D4FF">
                <circle cx="12" cy="12" r="10" stroke-width="1"/>
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M12 6v12m0 0c-1.5 0-3-1.5-3-3s1.5-3 3-3 3-1.5 3-3-1.5-3-3-3"/>
              </svg>
            <h3 class="text-center">Monthly Cash Challenges</h3>
            <b class="text-center">Real opportunities. Real rewards.</b>
            <p class="text-center">UMYO DFW challenges individuals and organizations to step up with innovative ideas and community-driven initiatives — for a chance to win:</p>
            <ul class="ps-3">
              <li >$5,000 and $10,000 cash awards</li>
              <li>Sponsorship and collaboration deals</li>
              <li>Exposure and connections to key partners</li>
            </ul> 
          </div>
          </div>
        </div>
        </div>
    </div>
  </div>
</section>
<!----END CARDS SECTION--->


<!----SPORTS SECTION--->
<section class="sports">
  <div class="container  py-5 hub" style="max-width: 900px;">
    <div class="row justify-content-center text-center">
      <div class="col-md-10">
        <h2 class="fw-bold mb-4" data-aos="fade-up">Why UMYO DFW Hub?</h2>
        <p class="lead" data-aos="fade-up">
          Because DFW doesn’t just need another program — it needs a platform built for purpose.
        </p>
        <p class=" mb-5" data-aos="fade-up">
           UMYO DFW is where entrepreneurs, students, organizers, and future leaders connect with:
        </p>
      </div>
    </div>

    <div class="row text-center g-4">
      <div class="col-md-3" data-aos="zoom-in">
        <div class="p-4 border rounded-4 shadow-sm h-100">
          <div class="mb-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"  class="bi bi-boxes" viewBox="0 0 16 16">
              <path d="M4.828.122a1 1 0 0 1 .765 0l2.572 1.03a1 1 0 0 1 .635.928v2.545a1 1 0 0 1-.635.928L5.593 6.584a1 1 0 0 1-.765 0L2.256 5.553a1 1 0 0 1-.635-.928V2.08a1 1 0 0 1 .635-.928L4.828.122ZM5 2.08 3.038 2.88v1.682L5 5.362l1.962-.8V2.88L5 2.08Zm6.672 4.043a1 1 0 0 1 .765 0l2.573 1.03a1 1 0 0 1 .635.928v2.545a1 1 0 0 1-.635.928l-2.573 1.03a1 1 0 0 1-.765 0l-2.572-1.03a1 1 0 0 1-.636-.928V8.081a1 1 0 0 1 .636-.928l2.572-1.03ZM12.5 8.04 10.538 8.84v1.682L12.5 11.362l1.962-.8V8.84L12.5 8.04Zm-8.922.125a1 1 0 0 1 .765 0l2.573 1.03a1 1 0 0 1 .635.928v2.545a1 1 0 0 1-.635.928l-2.573 1.03a1 1 0 0 1-.765 0l-2.572-1.03a1 1 0 0 1-.636-.928V10.123a1 1 0 0 1 .636-.928l2.572-1.03ZM5 10.08 3.038 10.88v1.682L5 13.362l1.962-.8v-1.682L5 10.08Z"/>
            </svg>
          </div>
          <h5 >Resources</h5>
        </div>
      </div>

      <div class="col-md-3" data-aos="zoom-in">
        <div class="p-4 border rounded-4 shadow-sm h-100">
          <div class="mb-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"  class="bi bi-people-fill" viewBox="0 0 16 16">
              <path d="M13 7c0 1.105-.672 2-1.5 2S10 8.105 10 7s.672-2 1.5-2S13 5.895 13 7ZM3 7c0 1.105.672 2 1.5 2S6 8.105 6 7s-.672-2-1.5-2S3 5.895 3 7Zm9.216 4.28A2.238 2.238 0 0 0 13.5 10h-3a2.238 2.238 0 0 0-1.284.28A2.106 2.106 0 0 1 9 12v1h5v-1c0-.388-.112-.749-.308-1.052a2.238 2.238 0 0 0-.476-.668ZM2 12a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1H2v-1Z"/>
            </svg>
          </div>
          <h5 >Local Partners</h5>
        </div>
      </div>

      <div class="col-md-3" data-aos="zoom-in">
        <div class="p-4 border rounded-4 shadow-sm h-100">
          <div class="mb-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"  class="bi bi-lightbulb-fill" viewBox="0 0 16 16">
              <path d="M2 6a6 6 0 1 1 12 0c0 1.866-.852 3.435-2.038 4.375C11.384 11.005 11 11.676 11 12.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5c0-.824-.384-1.495-.962-2.125C2.852 9.435 2 7.866 2 6Zm3.5 8a.5.5 0 0 1 .5.5v.5h4v-.5a.5.5 0 0 1 1 0v.5A1.5 1.5 0 0 1 9.5 16h-3A1.5 1.5 0 0 1 5 14.5v-.5a.5.5 0 0 1 .5-.5Z"/>
            </svg>
          </div>
          <h5 >Mentorship</h5>
        </div>
      </div>

      <div class="col-md-3" data-aos="zoom-in">
        <div class="p-4 border rounded-4 shadow-sm h-100">
          <div class="mb-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" class="bi bi-briefcase-fill" viewBox="0 0 16 16">
              <path d="M6.5 0a.5.5 0 0 0-.5.5V2H4a2 2 0 0 0-2 2v1h12V4a2 2 0 0 0-2-2h-2V.5a.5.5 0 0 0-.5-.5h-3ZM10 2H6v1h4V2Z"/>
              <path d="M0 6v7a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6H0Zm9 2.5a.5.5 0 0 1 .5-.5H14v1H9.5a.5.5 0 0 1-.5-.5Z"/>
            </svg>
          </div>
          <h5 >Opportunity</h5>
        </div>
      </div>
    </div>

    <div class="row mt-5 text-center">
      <div class="col">
        <p class="fs-5 " data-aos="fade-up">
          <strong>We amplify dreams and create real pathways to success — right here at home.</strong>
        </p>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row mt-5">
      <div class="col-md-6 mb-4 " data-aos="flip-left">
        <div class="membership-cards h-100 shadow rounded-4">
          <div class="card h-100">
            <h4 class="card-title ">For DFW Residents:</h4>
            <ul class="list-unstyled ps-3 my-3 text-start">
              <li>Build a profile highlighting your goals, skills, and achievements</li>
              <li>Access scholarships, grants, and giveaways</li>
              <li>Apply for featured local programs and community initiatives</li>
              <li>Promote your small business or local movement</li>
            </ul>
          </div>
        </div>        
      </div>

      <div class="col-md-6 mb-4 " data-aos="flip-right">
        <div class="membership-cards h-100 shadow rounded-4">
          <div class="card h-100">
            <h4 class="card-title ">For Local Leaders & Organizations:</h4>
            <ul class="list-unstyled ps-3 my-3 text-start">
              <li>Discover rising talent and changemakers in DFW</li>
              <li>Connect with potential partners, collaborators, or interns</li>
              <li>Offer support, resources, or sponsorship</li>
              <li>Lead workshops and mentorship inside our platform</li>
            </ul>
          </div>
        </div>        
      </div>

      <div class="col-md-6 mb-4 " data-aos="flip-left">
        <div class="membership-cards h-100 shadow rounded-4">
          <div class="card h-100">
            <h4 class="card-title ">Economic Opportunities Across DFW</h4>
            <p class="text-dark">UMYO connects residents with:</p>
            <ul class="list-unstyled ps-3 my-3 text-start">
              <li>Sponsorship deals</li>
              <li>Business development support</li>
              <li>Paid community roles and local initiatives</li>
              <li>Mentorship, financial planning, and access to capital</li>
            </ul>
          </div>
        </div>        
      </div>

      <div class="col-md-6 mb-4 " data-aos="flip-right">
      <div class="membership-cards h-100 shadow rounded-4">
          <div class="card h-100">
            <h4 class="card-title ">Business Networking & Digital Tools</h4>
            <p class="text-dark">In partnership with UMYO Wall Street of Technology, we offer:</p>
            <ul class="list-unstyled ps-3 my-3 text-start my-auto">
              <li>A digital business directory</li>
              <li>Community leader spotlights</li>
              <li>Real-time messaging and connection tools</li>
              <li>Opportunities to buy, sell, and collaborate locally</li>
            </ul>
          </div>
        </div>        
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row my-5 justify-content-center">
      <div class="col-md-10 my-5">
        <h1 class=" text-center text-white" data-aos="fade-up">Ambassadors of Impact</h1>
        <p class=" text-center mx-auto" data-aos="fade-up" style="max-width: 800px"><strong>Stevin “Hedake” Smith </strong>– DFW native, co-owner, and youth advocate mentoring residents to lead with purpose and ownership.</p>

        <p class=" text-center mx-auto" data-aos="fade-up" style="max-width: 800px"><strong>Isaac Cherry</strong>– UMYO co-founder and visionary helping everyday people create long-term economic empowerment through resources and strategy.</p>
      </div>
    </div>
  </div>
</section>
<!----END SPORTS SECTION--->

<!----PRIVACY,CONTROL SECTION--->
<section>
  <div class="privacy">
    <div class="container">
      <div class="row justify-content-center">
        <!-- <div class="col-lg-6 col-md-9">
          <div class="row">
            <div class="col-4">
              <div class="card  rounded" data-aos="zoom-in">
              <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 48 48"><path fill="#2C003E" d="M24 4c-5.5 0-10 4.5-10 10v4h4v-4c0-3.3 2.7-6 6-6s6 2.7 6 6v4h4v-4c0-5.5-4.5-10-10-10"/><path fill="#2C003E" d="M36 44H12c-2.2 0-4-1.8-4-4V22c0-2.2 1.8-4 4-4h24c2.2 0 4 1.8 4 4v18c0 2.2-1.8 4-4 4"/><circle cx="24" cy="31" r="6" fill="#2C003E"/><circle cx="24" cy="31" r="3" fill="#2C003E"/><circle cx="26" cy="29" r="1" fill="#2C003E"/></svg>
              <h3 >Privacy</h3>
            </div>
            </div>
            <div class="col-4">
              <div class="card  rounded-4" data-aos="zoom-in">
              <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 32 32"><g fill="#2C003E"><path d="M28.354 1.354a.5.5 0 0 0-.141-.805a5.98 5.98 0 0 0-6.798 1.191c-1.698 1.709-2.291 4.393-1.499 6.637L8.377 19.916a5.9 5.9 0 0 0-1.996-.336c-1.714 0-3.376.682-4.559 1.872a6.08 6.08 0 0 0-1.281 6.747a.498.498 0 0 0 .813.153l3.491-3.509c.23-.232.601-.263.793-.068l1.507 1.577c.219.221.209.562-.022.795l-3.478 3.5a.5.5 0 0 0 .141.804a6 6 0 0 0 2.591.588c1.572 0 3.065-.632 4.207-1.78c1.698-1.708 2.291-4.392 1.498-6.636l11.539-11.54a5.9 5.9 0 0 0 1.997.336c1.714 0 3.376-.682 4.559-1.872A6.08 6.08 0 0 0 31.458 3.8a.498.498 0 0 0-.813-.153l-3.491 3.509a.57.57 0 0 1-.801-.01l-1.499-1.499a.55.55 0 0 1-.001-.794zm-4.208 5l1.499 1.499c.599.602 1.625.605 2.218.009l2.93-2.944a5.09 5.09 0 0 1-1.324 4.926c-.997 1.003-2.399 1.577-3.85 1.577c-.683 0-1.33-.128-1.923-.38a.5.5 0 0 0-.549.106l-12 12a.5.5 0 0 0-.107.547c.803 1.91.314 4.375-1.163 5.861a4.96 4.96 0 0 1-4.985 1.258l2.941-2.96c.621-.625.631-1.594.029-2.198l-1.506-1.577c-.581-.585-1.614-.549-2.218.062l-2.93 2.944a5.09 5.09 0 0 1 1.324-4.926c.997-1.003 2.399-1.577 3.85-1.577c.683 0 1.33.128 1.923.38a.5.5 0 0 0 .549-.106l12-12a.5.5 0 0 0 .107-.547c-.803-1.91-.314-4.376 1.163-5.862a4.96 4.96 0 0 1 4.982-1.258l-2.96 2.961a1.546 1.546 0 0 0 0 2.205"/></g></svg>
              <h3 >Control</h3>

            </div>
            </div>
            <div class="col-4">
              <div class="card  rounded-4" data-aos="zoom-in">
              <svg xmlns="http://www.w3.org/2000/svg"  fill="#2C003E" viewBox="0 0 24 24">
                <path d="M20 7h-2.18A3 3 0 0 0 15 2a3 3 0 0 0-2.83 2H11.83A3 3 0 0 0 9 2a3 3 0 0 0-2.82 3H4a1 1 0 0 0 0 2h1v11a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V9h1a1 1 0 0 0 0-2zm-5-3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-6 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM8 20a1 1 0 0 1-1-1v-5h6v6H8zm8-1a1 1 0 0 1-1 1h-1v-6h6v5a1 1 0 0 1-1 1zM8 8v4H6V8h2zm10 4h-2V8h2v4z"/>
              <h3 >Reward</h3>

              </svg>
              </div>
            </div>
          </div>
        </div> -->
        <div class="col-md-10  mt-5">
          <div class="powered">
            <!-- <h3 class="fs-1 fw-bold mb-4" data-aos="fade-up">Welcome to the Future of Community—powered by UMYO Wall Street Of Technology.</h3>
            <p data-aos="fade-up">With all of these features integrated into one platform, UMYO Sports provides a comprehensive ecosystem that supports members in their personal and professional endeavors, whether they are entrepreneurs, creators, educators, or consumers. It offers tools for networking, monetization, privacy, content creation, mental health support, and more.</p>
            <a class="btn btn-hover-blue" href="#detailsSection" data-aos="fade-up">Read More</a> -->

            <h1 class="mt-5" data-aos="fade-up">Private, Gated Digital Communities</h1>
            <p class="text-start mt-4 fs-5" data-aos="fade-up"><strong>Join 10+ secure, local-focused groups built for DFW connection:</strong></p>
            <ul class="member-actions ps-0 list-unstyled text-start" data-aos="fade-up">
              <li>Safe, moderated spaces for real conversations</li>
              <li>Features like video conferencing, collaboration tools, and group meetups</li>
              <li>Tailored for students, families, small business owners, and more</li>
            </ul>
            
          </div>
        </div>
      </div>

      <!-- <div class="row my-5 pt-5 justify-content-center">
        <div class="col-12 text-center mb-4">
          <h1>Membership Benefits</h1>
        </div>
        <div class="col-md-5">
          <div class="card h-100  benefit">
             <h5>For Individual Members – $9.99/month</h5>  
             <ul class="ps-3">
              <li>Access to private livestreams, events, and giveaways</li>
              <li>Custom digital storefronts for veteran-owned brands</li>
              <li>Secure messaging and collaboration tools</li>
              <li>Weekly prize draws, scholarships, and military-only perks</li>
              <li>Branding and community marketing tools</li>
             </ul>          
          </div>
        </div>

        <div class="col-md-5">
          <div class="card h-100 benefit">
             <h5>For Sponsors & Organizations – $49.99/month</h5> 
             <ul class="ps-3">
              <li>Premium visibility across the UMYO Military Network</li>
              <li>Direct support of veterans and military families</li>
              <li>Access to sponsorship and outreach campaigns</li>
              <li>Marketing and recruitment tools for military-aligned causes</li>
             </ul>          
          </div>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-md-10  mt-5">
          <div class="powered">
            <h1 class="mt-5" data-aos="fade-up">Join the Mission-Driven Movement</h1>

            <p class="text-start mt-4 fs-5" data-aos="fade-up">
              We don’t just say <strong>“thank you for your service.”</strong><br>
              We build a platform that puts the power back in your hands.
            </p>

            <div class="pricing text-start mt-3 fs-5" data-aos="fade-up">
              <p><strong>Service Members:</strong> Sign up for just <strong>$9.99/month</strong></p>
              <p><strong>Military Organizations & Sponsors:</strong> Support the mission for <strong>$49.99/month</strong></p>
            </div>

            <p class="text-start mt-3 fs-5" data-aos="fade-up">
              No ads. No distractions. No gatekeeping.<br>
              Just ownership, opportunity, and a united military community building what's next — together.
            </p>

            <p class="text-start mt-4 fs-5" data-aos="fade-up">
              <strong>Join exclusive, moderated groups built for the military and veteran ecosystem:</strong>
            </p>

          </div>
        </div>
      </div> -->
    </div>
  </div>
</section>
<!----END PRIVACY,CONTROL SECTION--->



<!----READ MORE SECTION--->

<section id="detailsSection" class="overflow-hidden">
  <div class="container">
     <div class="row justify-content-center">
      <div class="col-lg-9">
        <h2 class="text-center  fs-1" data-aos="fade-up">Explore Our Secure Digital Ecosystems</h2>
          <p class="text-center  fs-5" data-aos="fade-up">DFW Community offers exclusive, private platforms designed to empower, train, and connect service members, veterans, families, and defense-based organizations.</p>
          <p class="text-center  fs-5" data-aos="fade-up"><strong>Click any platform below to learn more and explore your next secure mission-ready tool.</strong></p>
      </div>
     </div>
     <div class="row">
      <!-- <div class="col-md-4 p-3 " data-aos="fade-up">
        <div class="platform p-3">
          <img class="img-fluid lozad" src="assetses/img/PlatformsType/Military_SMS.png" alt="Image">
          <h3> DFW Community SMS/Email/Video Eblast</h3>
          
          <div class="description mt-3" style="display: none" id="sms">
            <span>Communicate. Alert. Mobilize.</span>
            <p><strong> DFW Community’s</strong> SMS, Email, and Video Eblast platform delivers fast, reliable, and secure communication for teams, commanders, and community leaders. Ideal for internal briefings, mission updates, and mass alerts.</p>
            <strong>Key Features:</strong>
            <ul>
              <li>Automated SMS and Email Campaigns</li>
              <li>Secure Video Messaging</li>
              <li>Real-Time Engagement Tracking</li>
              <li> Mission-Branded Templates & Alerts</li>
            </ul>
            <a href="javascript:void(0)"  id="sms_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2" >
            Read Less
          </a>
          </div>
          <a href="#sms" (click)="sectionShow('sms')"  id="sms_more_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 aos-init aos-animate" >
            Read More
          </a>          
        </div>
      </div> -->

      <div class="col-md-4 p-3 " data-aos="fade-up">
        <div class="platform p-3">
          <a href="https://dfwtalks.site">
          <img class="img-fluid lozad" src="assetses/img/PlatformsType/DFW_Talks.png" alt="Image">
        </a>
          <h3>DFW Community Talk</h3>
          
          <div class="description mt-3" style="display: none" id="talk">
            <span>Buy, Sell, Connect — Securely.</span>
            <p> A community-driven, military-friendly marketplace where veterans, service members, and families can exchange goods and services with trust and transparency.</p>
            <strong>Key Features:</strong>
            <ul>
              <li>Post Listings for Goods or Services</li>
              <li>Verified Military & Veteran Users</li>
              <li>Encrypted Communication Channels</li>
              <li> Promote Local Military Businesses</li>
            </ul>
            <a (click)="toggleSection('talk', false)"  id="talk_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2" >
            Read Less
          </a>
          </div>
          <a (click)="toggleSection('talk', true)"  id="talk_more_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read More
          </a>          
        </div>
      </div>

      <div class="col-md-4 p-3 " data-aos="fade-up">
        <div class="platform p-3">
          <a href="https://dfwtweets.site">
          <img class="img-fluid lozad" src="assetses/img/PlatformsType/DFW_Tweets.png" alt="Image">
        </a>
          <h3>DFW Community Tweets</h3>
          
          <div class="description mt-3" style="display: none" id="tweet">
            <p>A micro-posting platform for sharing secure updates, motivational messages, or quick check-ins. Ideal for military leaders, units, and peer-to-peer encouragement.</p>
            <strong>Key Features:</strong>
            <ul>
              <li> Mission-Focused Micro-Posts</li>
              <li>Topic Tracking & Team Communication</li>
              <li>No Ads or Noise</li>
              <li>Moderated for Security & Respect</li>
            </ul>
            <a (click)="toggleSection('tweet', false)"  id="tweet_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2" >
            Read Less
          </a>
          </div>
          <a (click)="toggleSection('tweet', true)"  id="tweet_more_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read More
          </a>          
        </div>
      </div>

      <div class="col-md-4 p-3 " data-aos="fade-up">
        <div class="platform p-3">
          <a href="https://umyoevents.site/">
          <img class="img-fluid lozad" src="assetses/img/PlatformsType/DFW_Events.png" alt="Image">
        </a>
          <h3>DFW Community Events</h3>
          
          <div class="description mt-3" style="display: none" id="event">
            <span>Host. Coordinate. Deploy.</span>
            <p>Plan and manage in-person and virtual events such as command briefings, unit celebrations, training seminars, or community outreach.</p>
            <strong>Key Features:</strong>
            <ul>
              <li> Mission-Ready Event Tools</li>
              <li>Secure QR Check-in</li>
              <li>Ticketing & Donation Options</li>
              <li>Cross-Platform Promotion</li>
            </ul>
            <a (click)="toggleSection('event', false)"  id="event_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read Less
          </a>
          </div>
          <a (click)="toggleSection('event', true)"  id="event_more_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read More
          </a>          
        </div>
      </div>

     </div>

     <div class="row">

      <div class="col-md-4 p-3 " data-aos="fade-up">
        <div class="platform p-3">
          <a href="https://upmradio.site">
          <img class="img-fluid lozad" src="assetses/img/PlatformsType/DFW_RAdio.png" alt="">
        </a>
          <h3>DFW Community Radio</h3>
          
          <div class="description mt-3" style="display: none" id="radio">
            <span>Stream. Share. Uplift.</span>
            <p>oadcast leadership talks, motivational audio, and unit stories. Great for morale boosting, informational streams, and cultural connection.</p>
            <strong>Key Features:</strong>
            <ul>
              <li>24/7 Military Radio Channels</li>
              <li>Host Live Briefs or Podcasts</li>
              <li>DJ Dashboard for Custom Content</li>
              <li>Secure Audio Chat Tools</li>
              
            </ul>
            <a (click)="toggleSection('radio', false)"  id="radio_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2" >
            Read Less
          </a>
          </div>
          <a (click)="toggleSection('radio', true)"  id="radio_more_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2" >
            Read More
          </a>          
        </div>
      </div>

      <div class="col-md-4 p-3 " data-aos="fade-up">
        <div class="platform p-3">
          <a href="https://umyoappt.site/">
          <img class="img-fluid lozad" src="assetses/img/PlatformsType/DFW_Appt_booking.png" alt="">
        </a>
          <h3 class="text-nowrap">DFW Community Appointments</h3>
          
          <div class="description mt-3" style="display: none" id="appoint">
            <span>Manage Schedules. Serve with Structure.</span>
            <p>Scheduling and booking tool for service providers, mental health professionals, chaplains, and base support services.</p>
            <strong>Key Features:</strong>
            <ul>
              <li>Branded Scheduling Site</li>
              <li>Automated Reminders</li>
              <li>Secure Payment & Booking Tools</li>
              <li>Professional Service Listings</li>
            </ul>
            <a (click)="toggleSection('appoint', false)"  id="appoint_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read Less
          </a>
          </div>
          <a (click)="toggleSection('appoint', true)"  id="appoint_more_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read More
          </a>          
        </div>
      </div>

      <div class="col-md-4 p-3 " data-aos="fade-up">
        <div class="platform p-3">
          <a href="https://umyomusic.site">
          <img class="img-fluid lozad" src="assetses/img/PlatformsType/DFW_Music.png" alt="">
        </a>
          <h3>DFW Community Music</h3>
          
          <div class="description" style="display: none;" id="music">
            <span>Honor. Inspire. Share the Sound.</span>
            <p> A music platform where veterans and military musicians can share, stream, and monetize their creative work.</p>
            <strong>Key Features:</strong>
            <ul>
              <li>Upload and Monetize Tracks</li>
              <li>Create & Share Military-Inspired Playlists</li>
              <li>Collaborate with Fellow Artists</li>
              <li>Music Discovery Within the Force</li>
            </ul>
            <a (click)="toggleSection('music', false)"  id="music_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2" >
            Read Less
          </a>
          </div>
          <a  id="music_more_btn" (click)="toggleSection('music', true)" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read More
          </a>          
        </div>
      </div>

     </div>

     <div class="row">

      <div class="col-md-4 p-3 " data-aos="fade-up">
        <div class="platform p-3">
          <a href="https://umyoconvo.site">
          <img class="img-fluid lozad" src="assetses/img/PlatformsType/DFW_Livestream.png" alt="">
        </a>
          <h3>DFW Community Livestream</h3>
          
          <div class="description" style="display: none;" id="stream">
            <span>Broadcast with Precision.</span>
            <p>Go live with secure video/audio streams for training, outreach, leadership updates, and community conversations</p>
            <strong>Key Features:</strong>
            <ul>
              <li>Stream Securely in Real-Time</li>
              <li>Interact with Viewers & Troops</li>
              <li> Mobile and Desktop Access</li>
              <li> Recordings and Archive Tools</li>
            </ul>
              <a (click)="toggleSection('stream', false)"  id="stream_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2  " >
            Read Less
          </a>

          </div>
          <a  id="stream_more_btn" (click)="toggleSection('stream', true)" class="btn btn-hover-purple border-dark  gap-2 mt-2" >
            Read More
          </a>          
        </div>
      </div>
      <!-- <div class="col-md-4 p-3 " data-aos="fade-up">
        <div class="platform p-3">
          <img class="img-fluid lozad" src="assetses/img/PlatformsType/Sports_Talk.png" alt="">
          <h3>Sports Talk</h3>
          
          <div class="description" style="display: none;" id="think">
            <span>Empower Minds. Elevate Futures.</span>
            <p>Roo Learning is a full-featured Learning Management System (LMS) designed to manage, deliver, and track educational courses and training programs. Whether you're an educator, a trainer, or a lifelong learner, UMYO Sports  Learning serves as your central hub to create, share, and engage with powerful educational experiences.</p>
            <ul>
              <li>Build and Host Interactive Courses</li>
              <li>Deliver Certifications, Workshops, and Trainings</li>
              <li>Track Learner Progress with Powerful Analytics</li>
              <li> Create Video Lessons, Quizzes, and Discussion Boards</li>
              <li> Engage Students Anytime, Anywhere — Mobile Friendly</li>
            </ul>
            <span>Teach boldly. Learn fearlessly. Grow together.
             Unlock your knowledge potential with ROO Learning.</span>
             <a href="javascript:void(0)"  id="think_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 aos-init aos-animate " >
            Read Less
          </a>
          </div>
          <a href="#think" id="think_more_btn" (click)="sectionShow('think')" class="btn btn-hover-purple border-dark  gap-2 mt-2 aos-init aos-animate" >
            Read More
          </a>          
        </div>
      </div> -->
      <div class="col-md-4 p-3 " data-aos="fade-up">
        <div class="platform p-3">
          <a href="https://umyomilitary.site">
          <img class="img-fluid lozad" src="assetses/img/PlatformsType/dfw_dating.png" alt="">
        </a>
          <h3>DFW Community Dating</h3>
          
          <div class="description" style="display: none;" id="dating">
            <span>Connect with Purpose.</span>
            <p>A respectful and private matchmaking platform for veterans and active-duty members seeking like-minded partners with shared values.</p>
            <strong>Key Features:</strong>
            <ul>
              <li> Verified Military Profiles</li>
              <li>Secure Messaging & Matchmaking</li>
              <li>Common-Interest-Based Pairing</li>
              <li>Private, Moderated Community</li>
            </ul>
            <a (click)="toggleSection('dating', false)"  id="dating_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read Less
          </a>
          </div>
          <a  id="dating_more_btn" (click)="toggleSection('dating', true)"  class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read More
          </a>          
        </div>
      </div>

      <div class="col-md-4 p-3 " data-aos="fade-up">
        <div class="platform p-3">
          <a href="#">
          <img class="img-fluid lozad" src="assetses/img/PlatformsType/DFW_Fans.png" alt="">
        </a>
          <h3>DFW Community Fans</h3>
          
          <div class="description" style="display: none;" id="fans">
            <span>Support. Subscribe. Sustain.</span>
            <p>A platform for military creators, influencers, and advocates to share premium content with subscribers and build a sustainable support base.</p>
            <strong>Key Features:</strong>
            <ul>
              <li>Subscription Models</li>
              <li>Share Exclusive Videos & Posts</li>
              <li>Connect Deeply with Supporters</li>
              <li>Military Audience Monetization</li>
            </ul>

            <a (click)="toggleSection('fans', false)"  id="fans_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read Less
          </a>
          </div>
          <a  id="fans_more_btn" (click)="toggleSection('fans', true)" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read More
          </a>          
        </div>
      </div>

     </div>

      <div class="row">
      <div class="col-md-4 p-3 " data-aos="fade-up">
        <div class="platform p-3">
          <a href="javascript:void(0)">
          <img class="img-fluid lozad" src="assetses/img/PlatformsType/DFW_estore.png" alt="">
        </a>
          <h3>DFW Community eStore</h3>
          
          <div class="description" style="display: none;" id="store">.
            <span>Supply. Sell. Serve.</span>
            <p>Create an online storefront to offer apparel, tactical gear, training programs, and other goods or services within a secure ecosystem.</p>
            <strong>Key Features:</strong>
            <ul>
              <li>Sell Military-Branded Products</li>
              <li>Manage Inventory & Orders</li>
              <li>Secure Payment Integration</li>
              <li>Custom Storefront Design</li>
            </ul>
            <a (click)="toggleSection('store', false)"  id="store_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read Less
          </a>
          </div>
          <a  id="store_more_btn" (click)="toggleSection('store', true)" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read More
          </a>          
        </div>
      </div>

      <!-- <div class="col-md-4 p-3 " data-aos="fade-up">
        <div class="platform p-3">
          <img class="img-fluid lozad" src="assetses/img/PlatformsType/Military_Conferencing.png" alt="">
          <h3>DFW Community Conferencing</h3>
          
          <div class="description" style="display: none;" id="conference">
            <p><strong>Convene and Collaborate.</strong></p>
            <p>Secure digital meeting rooms for briefings, leadership development, training sessions, or peer-to-peer conversations.</p>
            <strong>Key Features:</strong>
            <ul>
              <li>Encrypted Audio/Video Rooms</li>
              <li>Invite-Only Access</li>
              <li>Live Chat & Screen Share</li>
              <li> Session Recording & Archiving</li>
            </ul>
            <a href="javascript:void(0)"  id="conference_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 aos-init aos-animate " >
            Read Less
          </a>
          </div>
          <a href="javascript:void(0)conference" id="conference_more_btn" (click)="sectionShow('conference')"  class="btn btn-hover-purple border-dark  gap-2 mt-2 aos-init aos-animate" >
            Read More
          </a>          
        </div>
      </div> -->

      <!-- <div class="col-md-4 p-3 " data-aos="fade-up">
        <div class="platform p-3">
          <img class="img-fluid lozad" src="assetses/img/PlatformsType/military_youth.png" alt="">
          <h3>DFW Community Youth</h3>
          
          <div class="description" style="display: none;" id="youth">
            <span>Train Tomorrow’s Leaders.</span>
            <p> A secure digital marketplace and learning space for military youth to explore entrepreneurship and leadership.</p>
            <strong>Key Features:</strong>
            <ul>
              <li>Youth-Driven Stores & Projects</li>
              <li>Parent-Supervised Accounts </li>
              <li>Mentorship Opportunities</li>
              <li>Intro to Business & Financial Literacy</li>
            </ul>
            <a href="javascript:void(0)"  id="youth_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 aos-init aos-animate " >
            Read Less
          </a>
          </div>
          <a href="javascript:void(0)youth" id="youth_more_btn" (click)="sectionShow('youth')" class="btn btn-hover-purple border-dark gap-2 mt-2 aos-init aos-animate" >
            Read More
          </a>          
        </div>
      </div> -->

      <div class="col-md-4 p-3 " data-aos="fade-up">
        <div class="platform p-3">
          <a href="javascript:void(0)">
          <img class="img-fluid lozad" src="assetses/img/PlatformsType/DFW_Smart_Chats.png" alt="">
        </a>
          <h3>DFW Community AI Chat</h3>
          
          <div class="description" style="display: none;" id="chat">
            <span>Your Secure AI Assistant for the Field and Beyond.</span>
            <p>DFW Community ChatGPT is a custom AI solution built for military communication, logistics, training, and decision support—protected by DFW’s VPN encryption layer.</p>
            <strong>AI Capabilities Built for the Mission:</strong>
            <ul>
              <li>Secure, Encrypted Military-Grade AI Access</li>
              <li> Language Translation & Real-Time Briefing Support</li>
              <li>Task Automation for Daily Operations</li>
              <li>Secure Q&A for SOPs, Protocols, & Manuals</li>
              <li>Offline & Low-Bandwidth Compatible Modes</li>
            </ul>
            <span>Think faster. Communicate smarter. Operate safer—with UMYO AI.</span>
            <a (click)="toggleSection('chat', false)"  id="chat_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2" >
            Read Less
          </a>
          </div>
          <a  id="chat_more_btn" (click)="toggleSection('chat', true)" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read More
          </a>          
        </div>
      </div>

      <div class="col-md-4 p-3 " data-aos="fade-up">
        <div class="platform p-3">
          <a href="javascript:void(0)">
          <img class="img-fluid lozad" src="assetses/img/PlatformsType/dfw_giveaways.png" alt="">
        </a>
          <h3>DFW Community Prize Giveaway</h3>
          
          <div class="description" style="display: none;" id="prize">
            <span>Boost Morale. Recognize Service.</span>
            <p>Gamify engagement with giveaways that reward loyalty and promote participation in military-related campaigns.</p>
            <strong>Key Features:</strong>
            <ul>
              <li>Run Contests or Sweepstakes</li>
              <li>Recognize Troop Engagement</li>
              <li>Real-Time Prize Distribution</li>
              <li>Track & Analyze Results</li>
            </ul>
            <a (click)="toggleSection('prize', false)"  id="prize_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2  " >
            Read Less
          </a>
          </div>
          <a  id="prize_more_btn" (click)="toggleSection('prize', true)" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read More
          </a>          
        </div>
      </div>


     </div>

     <div class="row">
      <div class="col-md-4 p-3 " data-aos="fade-up">
        <div class="platform p-3">
          <a href="javascript:void(0)">
          <img class="img-fluid lozad" src="assetses/img/PlatformsType/DFW_Digital_coupons.png" alt="">
        </a>
          <h3>DFW Community Coupon Booklet</h3>
          
          <div class="description mt-3" style="display: none" id="book">
            <span>Support Military Families.</span>
            <p>Provide local and national discounts to service members, veterans, and their families through digital coupon booklets.</p>
            <strong>Key Features:</strong>
            <ul>
              <li>Hyper-Targeted Military Ads</li>
              <li>QR Code Coupon Integration</li>
              <li>Loyalty & Rewards System</li>
              <li>Campaign Performance Tracking</li>
            </ul>
            <a (click)="toggleSection('book', false)"  id="book_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read Less
          </a>
          </div>
          <a (click)="toggleSection('book', true)"  id="book_more_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read More
          </a>          
        </div>
      </div>

      <div class="col-md-4 p-3 " data-aos="fade-up">
        <div class="platform p-3">
          <a href="javascript:void(0)">
          <img class="img-fluid lozad" src="assetses/img/PlatformsType/dfw_digital_mag.png" alt="">
        </a>
          <h3> DFW Community Video Magazine</h3>
          
          <div class="description mt-3" style="display: none" id="magazine">
            <span>Mission-Driven Storytelling.</span>
            <p> A digital video magazine to highlight military life, unit achievements, leadership messages, and training content.</p>
            <strong>Key Features:</strong>
            <ul>
              <li>Branded Video Layouts</li>
              <li> Leadership Spotlights</li>
              <li>Shareable Across Networks</li>
              <li>Archive for Ongoing Engagement</li>
            </ul>
            <a (click)="toggleSection('magazine', false)"  id="magazine_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read Less
          </a>
          </div>
          <a (click)="toggleSection('magazine', true)"  id="magazine_more_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read More
          </a>          
        </div>
      </div>
      <div class="col-md-4 p-3 " data-aos="fade-up">
        <div class="platform p-3">
          <a href="javascript:void(0)">
          <img class="img-fluid lozad" src="assetses/img/PlatformsType/dfw_daily_news.png" alt="">
        </a>
          <h3>DFW Community News</h3>
          
          <div class="description" style="display: none;" id="news">
            <span>Stay Informed. Stay Ahead.</span>
            <p> A real-time, curated news experience built for service members, veterans, and military families.</p>
            <strong>Key Features:</strong>
            <ul>
              <li> Military-Centric Headlines</li>
              <li>Global & Domestic Security Coverage</li>
              <li>Real-Time Updates</li>
              <li> Comment & Community Forums</li>
            </ul>
            <a (click)="toggleSection('news', false)"  id="news_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read Less
          </a>
          </div>
          <a  id="news_more_btn" (click)="toggleSection('news', true)" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read More
          </a>          
        </div>
      </div>
      <div class="col-md-4 p-3 " data-aos="fade-up">
        <div class="platform p-3">
          <a href="javascript:void(0)">
          <img class="img-fluid lozad" src="assetses/img/PlatformsType/DFW_video.png" alt="">
        </a>
          <h3>DFW Community Video</h3>
          
          <div class="description" style="display: none;" id="talent">
            <span>Your Voice. Your Mission.</span>
            <p> Upload, host, and share secure videos for internal communications, leadership training, and mission briefs.</p>
            <strong>Key Features:</strong>
            <ul>
              <li>Ad-Free Viewing</li>
              <li>Live Chat & Comments</li>
              <li> Playlist & Channel Creation</li>
              <li>Role-Based Access Control</li>
              <li>Email: video&#64;umyovideo.com</li>
            </ul>
            <a (click)="toggleSection('talent', false)"  id="talent_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read Less
          </a>
          </div>
          <a  id="talent_more_btn" (click)="toggleSection('talent', true)" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read More
          </a>          
        </div>
      </div>

      <div class="col-md-4 p-3 " data-aos="fade-up">
        <div class="platform p-3">
          <a href="javascript:void(0)">
          <img class="img-fluid lozad" src="assetses/img/PlatformsType/dfw_games.png" alt="">
        </a>
          <h3>DFW Community Games</h3>
          
          <div class="description" style="display: none;" id="game">
            <span>Game. Compete. Connect — Securely.</span>
            <p>Enjoy a curated collection of competitive online games tailored for military personnel—accessible securely through DFW Community Games. Whether for stress relief or team bonding, game without borders or risks.</p>
            <strong>Online Gaming Highlights:</strong>
            <ul>
              <li>Low-Latency Servers for Seamless Play</li>
              <li>Access Region-Locked Games Anywhere</li>
              <li>Multiplayer Matchmaking with Encrypted Privacy</li>
              <li>Squad-Based Military Strategy Titles</li>
              <li>Weekly Tournaments & Leaderboards</li>
            </ul>
            <strong>Play smart. Play secure. With UMYO.</strong>
            <a (click)="toggleSection('game', false)"  id="game_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read Less
          </a>
          </div>
          <a  id="game_more_btn" (click)="toggleSection('game', true)" class="btn btn-hover-purple border-dark  gap-2 mt-2 " >
            Read More
          </a>          
        </div>
      </div>

      <div class="col-md-4 p-3 " data-aos="fade-up">
        <div class="platform p-3">
          <a href="javascript:void(0)">
          <img class="img-fluid lozad" src="assetses/img/PlatformsType/dfw_vpn.png" alt="">
        </a>
          <h3>DFW Community VPN</h3>
          
          <div class="description" style="display: none;" id="vpn">
            <span>Protect Your Privacy. Empower Your Freedom.</span>
            <p>DFW Community VPN offers government-grade encryption to protect military members' digital footprint. Whether on deployment or remote base access, your data remains yours.</p>
            <strong>Key Features:</strong>
            <ul>
              <li>One-Click Secure Connection</li>
              <li>Identity & Data Protection</li>
              <li> Global Content Access</li>
              <li> No-Logs Policy</li>
              <li>Fast, Encrypted Servers</li>
            </ul>
            <button (click)="toggleSection('vpn', false)"  id="vpn_less_btn"  class="btn btn-hover-purple border-dark  gap-2 mt-2  " >
            Read Less
          </button>
          </div>
          <a  id="vpn_more_btn" (click)="toggleSection('vpn', true)" class="btn btn-hover-purple border-dark  gap-2 mt-2" >
            Read More
          </a>          
        </div>
      </div>

      <!-- <div class="col-md-4 p-3 " data-aos="fade-up">
        <div class="platform p-3">
          <img class="img-fluid lozad" src="assetses/img/PlatformsType/Military_Web_Hosting.png" alt="">
          <h3>DFW Community Hosting</h3>
          
          <div class="description" style="display: none;" id="hosting">
            <span>Secure Infrastructure for Military Teams & Missions.</span>
            <p>DFW Community Hosting delivers private, encrypted cloud and server hosting built for defense-grade reliability and control. From mission-critical apps to unit collaboration portals, host with confidence—anywhere, anytime.</p>
            <strong>Hosting Advantages:</strong>
            <ul>
              <li>Military-Grade Server Encryption</li>
              <li>Scalable Cloud & Dedicated Server Options</li>
              <li> 24/7 Threat Monitoring & Support</li>
              <li>Global Deployment Availability</li>
              <li>Secure File Storage & App Hosting</li>
            </ul>
            <strong>Mission-ready hosting. Backed by UMYO.</strong>
            <button   id="hosting_less_btn" (click)="hide()" class="btn btn-hover-purple border-dark  gap-2 mt-2 aos-init aos-animate " >
            Read Less
          </button>
          </div>
          <a href="#hosting" id="hosting_more_btn" (click)="sectionShow('hosting')" class="btn btn-hover-purple border-dark  gap-2 mt-2" >
            Read More
          </a>          
        </div>
      </div> -->

      <div class="col-md-4 p-3 " data-aos="fade-up">
        <div class="platform p-3">
          <a href="javascript:void(0)">
          <img class="img-fluid lozad" src="assetses/img/PlatformsType/DFW_menopause.png" alt="">
        </a>
          <h3>Military Men No Pause</h3>
          
          <div class="description" style="display: none;" id="men">
            <span>A Weekly Private Space for Men to Share, Cry, Learn, Heal & Find Purpose
            For Warriors. By Warriors.</span>
            
            <p>Behind every uniform is a man carrying weight most will never see. Military Men No Pause is a confidential, judgment-free space where servicemen—young and old—can gather weekly to speak freely, feel deeply, and grow stronger together.</p>
            <strong>What It Is:</strong>
            <p>A secure, private online or in-person gathering space held once a week, exclusively for military men—active duty, veterans, and reservists.</p>
            <strong>What Happens Here:</strong>
            <ul>
              <li><strong>Share:</strong> Open up about life, stress, family, trauma, transitions.</li>
              <li><strong>Cry:</strong> Let it out. No shame. No weakness. Just the truth.</li>
              <li><strong>Learn:</strong> Hear from others, mentors, and professionals.</li>
              <li><strong>Heal:</strong> Rebuild from the inside out, with support.</li>
              <li><strong>Find Purpose:</strong> Rediscover why you serve, who you are, and where you’re going.</li>
              
            </ul>
            <span>Why It Matters:</span>
            <p>The mission doesn’t end when the deployment does. Brotherhood doesn’t stop outside the base. This is the space for the next kind of strength—emotional resilience, connection, and clarity.</p>
            <strong>Private. Safe. No Rank. No Judgement. No Pause.
            Join the movement. Military Men. No Pause.</strong>
            <button (click)="toggleSection('men', false)"  id="men_less_btn" class="btn btn-hover-purple border-dark  gap-2 mt-2" >
            Read Less
          </button>
          </div>
          <a  id="men_more_btn" (click)="toggleSection('men', true)" class="btn btn-hover-purple border-dark  gap-2 mt-2" >
            Read More
          </a>          
        </div>
      </div>
     </div>

  </div>
</section>

<!-- ════════ FOOTER ════════ -->
<footer class="ufoot">
  <div class="container">
    <img src="assetses/img/logo.png" alt="UMYOBizDFW" onerror="this.style.display='none'">
    <div class="ufb">UMYOBizDFW</div>
    <p>DFW's First Privacy-Gated Digital Community</p>
    <div class="d-flex justify-content-center gap-4 flex-wrap">
      <a href="/">Home</a>
      <a href="/about">About Us</a>
      <a routerLink="/networks">Network</a>
      <a routerLink="/hub">Hub</a>
      <a routerLink="/anti-bullying">Anti-Bullying</a>
      <a routerLink="/community-impact">Community Fund</a>
      <a routerLink="/empower-youth">Empower Youth</a>
      <a routerLink="/services">Type of Servcies</a>
      <a routerLink="/cf">Card Features</a>
      <a href="/terms">Terms &amp; Conditions</a>
    </div>
    <p class="ufc2">© 2025 UMYOBizDFW · Built by the community, for the community</p>
  </div>
</footer>